"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createTransfer = void 0;

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _payouts = require("@module/payouts");

var _request = _interopRequireDefault(require("@package/request"));

var _utils = require("@package/utils");

var _logger = require("@package/logger");

var _errors = require("@package/errors");

var _dialog = require("@package/dialog");

var notifications = _interopRequireWildcard(require("@package/notifications"));

var _slice = require("../slice");

var createTransfer = function createTransfer(formData) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(dispatch) {
      var amount, payout, result, item, count, notExit, _yield$request, data;

      return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              (0, _logger.push)({
                owner: 'Navigate',
                message: 'Запрос на создание перевода по id: ' + formData['externalId']
              });
              dispatch((0, _slice.createPayoutRequestAction)());
              amount = formData['sender']['isShowCommissionCalculation'] ? formData['amount-credit'] : formData['amount'];
              payout = {
                amount: amount,
                externalId: formData['externalId'],
                currency: formData['account']['name'],
                description: formData['description'],
                paymentMethod: 'Transfer'
              };
              payout['destination'] = String(formData['recipient']['id']);
              payout['shopId'] = formData['sender']['id'];
              _context.next = 9;
              return (0, _request["default"])({
                url: '/payouts',
                method: 'post',
                data: payout
              });

            case 9:
              result = _context.sent;
              item = null;
              count = 0;
              notExit = true;

            case 13:
              (0, _logger.push)({
                owner: 'Navigate',
                message: 'Опрос созданного перевода по id: ' + result['data']['externalId']
              });
              ++count;
              _context.next = 17;
              return (0, _utils.sleep)(window.env['ATTEMPT_WAIT']);

            case 17:
              _context.next = 19;
              return (0, _request["default"])({
                url: "/payouts",
                method: 'get',
                params: {
                  externalId: result['data']['externalId']
                }
              });

            case 19:
              _yield$request = _context.sent;
              data = _yield$request.data;

              if (data.length > 0) {
                if (data[0]['externalId'] === result['data']['externalId']) {
                  if (data[0]['status']['code'] > 1 && data[0]['status']['code'] < 999) {
                    notExit = false;
                    item = data[0];
                  }
                }
              }

              if (!(count >= Number(window.env['ATTEMPT_COUNT']))) {
                _context.next = 24;
                break;
              }

              throw {
                data: {
                  code: '1.1.1'
                }
              };

            case 24:
              if (notExit) {
                _context.next = 13;
                break;
              }

            case 25:
              dispatch((0, _slice.createPayoutRequestSuccessAction)());
              dispatch((0, _payouts.createPayoutsRequestSuccessAction)(item));
              dispatch((0, _dialog.closeDialog)('create-payout'));

              if (result['data']['token2FA']) {
                (0, _logger.push)({
                  owner: 'Navigate',
                  message: 'Необходимо ввести TwoFA для подтверждения перевода по id: ' + formData['externalId']
                });
                dispatch((0, _dialog.openDialog)('confirm-twoFA', {
                  id: item['id']
                }));
              } else {
                dispatch(notifications.push({
                  title: "\u041F\u0435\u0440\u0435\u0432\u043E\u0434 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D",
                  content: "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u044F \u2116".concat(formData['externalId']),
                  mode: 'success',
                  autoClose: true
                }));
              }

              (0, _logger.push)({
                owner: 'Navigate',
                message: 'Перевод успешно выполнен по id: ' + formData['externalId']
              });
              _context.next = 39;
              break;

            case 32:
              _context.prev = 32;
              _context.t0 = _context["catch"](0);

              if (!(_context.t0 instanceof _errors.UnauthorizedError)) {
                _context.next = 36;
                break;
              }

              return _context.abrupt("return", void 0);

            case 36:
              dispatch((0, _slice.createPayoutRequestFailAction)(_context.t0['data']));
              dispatch(notifications.pushFail(_context.t0['data']));
              (0, _logger.push)({
                owner: 'Navigate',
                level: 'error',
                message: 'Ошибка при создании перевода по id: ' + formData['externalId']
              });

            case 39:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 32]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.createTransfer = createTransfer;